<template>
<div class="performance-statistics page-box">
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="8"
        :md="8"
        :sm="12"
        :xs="24"
      >
        <div class="label">{{$t('Opening_time')}}</div>
        <el-date-picker
          v-if="!realMobile"
          style="width: 100%"
          v-model="date"
          type="daterange"
          value-format="yyyy-MM-dd"
          :range-separator="$t('root.dateTo')"
          :start-placeholder="$t('root.startDate')"
          :end-placeholder="$t('root.endDate')"
        >
        </el-date-picker>
        <select-date-duration
          class="header-sub-item"
          v-model="date"
        ></select-date-duration>
      </el-col>
    </el-row>
  </div>
  <div class="page-content">
    <div class="tab-inner">
      <div
        v-for="(item,index) in navList"
        :key="index"
        :style="getStyle(item)"
        @click="navHandle(item)"
        class="tab-item pointer"
      >{{item.label}}</div>
    </div>
    <router-view
      :time-date="date"
    ></router-view>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { colorRgba } from "@/utils/index";
import { parseTime,init_date } from '@/utils/index'
export default {
  name: "index",
  data() {
    let _this = this;
    return {
      date: [], // 时间
      navList: [
        {label: _this.$t('Straight_off'), routerName: 'customerPerformanceStatistics'},
        {label: _this.$t('sub_IB'), routerName: 'subIbPerformanceStatistics'},
      ],
    }
  },
  computed: {
    ...mapGetters(['themeColor','realMobile']),
  },
  created(){
    this.getInitDate();
  },
  methods: {
    getInitDate() {
      this.date = [init_date().oneMonAgo,init_date().today];
    },
    getStyle(item){
      if(item.routerName == this.$route.name){
        return {
          backgroundColor: colorRgba(this.themeColor,0.1),
        }
      }
    },
    navHandle(item){
      this.$router.push({name: item.routerName});
    },
  },
}
</script>

<style lang="scss" scoped>
.performance-statistics {
  .tab-inner {
    padding: 20px;
    padding-bottom: 0;
  }
}
</style>
